import React, { useState } from 'react';
import { Collapse } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { SectionKey, ShowDetails } from './types';
import { ANALYTICS_CARDS, createShowDetailsFromKeys } from './constants';
import {
  Container,
  MainContent,
  PageTitle,
  CardsGrid,
  AnalyticsCard as StyledAnalyticsCard,
  CardTitle,
  CardDescription,
  DetailsContainer,
  StyledCollapse,
  DetailTitle,
  DetailText,
} from './styles';

const { Panel } = Collapse;

const ManagerAnalytics: React.FC = () => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };
  const [showDetails, setShowDetails] = useState<ShowDetails>({
    staffManagement: false,
    dailyOperations: false,
    customerFeedback: false,
  });

  const toggleDetails = (section: SectionKey) => {
    setShowDetails((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const activeKeys = Object.entries(showDetails).filter(([_, isOpen]) => isOpen).map(([key]) => key);

  const handleCollapseChange = (keys: string | string[]) => {
    const keysArray = Array.isArray(keys) ? keys : [keys];
    const newShowDetails = createShowDetailsFromKeys(keysArray);
    setShowDetails(newShowDetails);
  };

  return (
    <Container>
      <MainContent>
        <PageTitle level={2} theme={theme}>
          Analytics
        </PageTitle>

        <CardsGrid>
          {ANALYTICS_CARDS.map((card) => (
            <StyledAnalyticsCard
              key={card.key}
              isSelected={showDetails[card.key]}
              theme={theme}
              onClick={() => toggleDetails(card.key)}
            >
              <CardTitle level={4} theme={theme}>
                {card.title}
              </CardTitle>
              <CardDescription theme={theme}>{card.description}</CardDescription>
            </StyledAnalyticsCard>
          ))}
        </CardsGrid>

        <DetailsContainer>
          <StyledCollapse
            activeKey={activeKeys}
            onChange={handleCollapseChange}
            theme={theme}
          >
            <Panel header="Staff Management Details" key="staffManagement">
              <DetailTitle level={4} theme={theme}>
                Staff Management Details
              </DetailTitle>
              <DetailText theme={theme}>
                Detailed report on staff management...
              </DetailText>
            </Panel>
            <Panel header="Daily Operations Details" key="dailyOperations">
              <DetailTitle level={4} theme={theme}>
                Daily Operations Details
              </DetailTitle>
              <DetailText theme={theme}>
                Detailed report on daily operations...
              </DetailText>
            </Panel>
            <Panel header="Customer Feedback Details" key="customerFeedback">
              <DetailTitle level={4} theme={theme}>
                Customer Feedback Details
              </DetailTitle>
              <DetailText theme={theme}>
                Detailed report on customer feedback...
              </DetailText>
            </Panel>
          </StyledCollapse>
        </DetailsContainer>
      </MainContent>
    </Container>
  );
};

export default ManagerAnalytics;
